var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goETC"},[_c('section',{staticClass:"page-content"},[_c('p',[_vm._v("1、打开微信，在搜索框输入ETC助手进行搜索")]),_c('p',[_vm._v("2、点击ETC助手则可进入ETC助手小程序")]),_c('img',{attrs:{"src":require("../../assets/pakd/goETC.png"),"alt":""}})]),_c('section',{staticClass:"page-bottom"})])
}]

export { render, staticRenderFns }